import React from "react";

export type BadgeVariant =
  | "verified"
  | "pending"
  | "rejected"
  | "not-uploaded"
  | "connected"
  | "not-connected"
  | "running"
  | "ready"
  | "failed"
  | "cancelled"
  | "expired"
  | "match"
  | "audit-logged";

interface StatusBadgeProps {
  variant: BadgeVariant;
  label?: string;
}

const CONFIG: Record<BadgeVariant, { bg: string; text: string; symbol: string; defaultLabel: string }> = {
  "verified":       { bg: "bg-green-100",  text: "text-green-700",  symbol: "✓", defaultLabel: "verified"       },
  "pending":        { bg: "bg-orange-100", text: "text-orange-600", symbol: "●", defaultLabel: "pending"        },
  "rejected":       { bg: "bg-red-100",    text: "text-red-700",    symbol: "✕", defaultLabel: "Rejected"       },
  "not-uploaded":   { bg: "bg-gray-100",   text: "text-gray-500",   symbol: "—", defaultLabel: "Not Uploaded"   },
  "connected":      { bg: "bg-green-100",  text: "text-green-700",  symbol: "✓", defaultLabel: "Connected"      },
  "not-connected":  { bg: "bg-gray-100",   text: "text-gray-500",   symbol: "—", defaultLabel: "Not Connected"  },
  "running":        { bg: "bg-amber-100",  text: "text-amber-700",  symbol: "●", defaultLabel: "running"        },
  "ready":          { bg: "bg-green-100",  text: "text-green-700",  symbol: "●", defaultLabel: "ready"          },
  "failed":         { bg: "bg-red-100",    text: "text-red-700",    symbol: "●", defaultLabel: "failed"         },
  "cancelled":      { bg: "bg-gray-100",   text: "text-gray-500",   symbol: "●", defaultLabel: "cancelled"      },
  "expired":        { bg: "bg-gray-100",   text: "text-gray-500",   symbol: "●", defaultLabel: "expired"        },
  "match":          { bg: "bg-green-100",  text: "text-green-700",  symbol: "●", defaultLabel: "match"          },
  "audit-logged":   { bg: "bg-cyan-100",   text: "text-cyan-700",   symbol: "●", defaultLabel: "audit-logged"   },
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ variant, label }) => {
  const { bg, text, symbol, defaultLabel } = CONFIG[variant];
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${bg} ${text}`}>
      <span className="text-[10px]">{symbol}</span>
      {label ?? defaultLabel}
    </span>
  );
};
